var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            top: "6vh",
            width: "80%",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "content", staticStyle: { width: "100%" } },
            [
              _c(
                "el-form",
                {
                  ref: "ruleForm",
                  staticClass: "demo-ruleForm",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-width": "100px",
                  },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: _vm.col } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "调拨日期", prop: "date" } },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "value-format": "yyyy-MM-dd",
                                  type: "date",
                                  placeholder: "选择日期",
                                },
                                model: {
                                  value: _vm.form.date,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "date", $$v)
                                  },
                                  expression: "form.date",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "备注" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  type: "textarea",
                                  rows: 1,
                                  placeholder: "请输入",
                                },
                                model: {
                                  value: _vm.form.remark,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "remark", $$v)
                                  },
                                  expression: "form.remark",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "提交人", prop: "submit" } },
                            [_c("span", [_vm._v(_vm._s(_vm.form.submit))])]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 5 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "出库单号", prop: "batchNo" } },
                            [_c("span", [_vm._v(_vm._s(_vm.form.batchNo))])]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 3 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "本次调拨总数" } },
                            [_c("span", [_vm._v(_vm._s(_vm.total))])]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-divider"),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "center" },
                [
                  _c("div", { staticClass: "header" }, [
                    _c(
                      "div",
                      { staticClass: "lf" },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入款号" },
                          on: { blur: _vm.press },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.press($event)
                            },
                          },
                          model: {
                            value: _vm.search.styleNo,
                            callback: function ($$v) {
                              _vm.$set(_vm.search, "styleNo", $$v)
                            },
                            expression: "search.styleNo",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          attrs: { placeholder: "请输入颜色" },
                          on: { blur: _vm.press },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.press($event)
                            },
                          },
                          model: {
                            value: _vm.search.color,
                            callback: function ($$v) {
                              _vm.$set(_vm.search, "color", $$v)
                            },
                            expression: "search.color",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          attrs: { placeholder: "请输入尺码" },
                          on: { blur: _vm.press },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.press($event)
                            },
                          },
                          model: {
                            value: _vm.search.size,
                            callback: function ($$v) {
                              _vm.$set(_vm.search, "size", $$v)
                            },
                            expression: "search.size",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          attrs: { placeholder: "请输入仓库" },
                          on: { blur: _vm.press },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.press($event)
                            },
                          },
                          model: {
                            value: _vm.search.warehouse,
                            callback: function ($$v) {
                              _vm.$set(_vm.search, "warehouse", $$v)
                            },
                            expression: "search.warehouse",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          attrs: { placeholder: "请输入库位号" },
                          on: { blur: _vm.press },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.press($event)
                            },
                          },
                          model: {
                            value: _vm.search.location,
                            callback: function ($$v) {
                              _vm.$set(_vm.search, "location", $$v)
                            },
                            expression: "search.location",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "rt" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.press },
                          },
                          [_vm._v("查 询")]
                        ),
                        _vm._v(" "),
                        _c("img", {
                          attrs: {
                            src: require("@/assets/image/shuaxin.png"),
                            alt: "",
                          },
                          on: { click: _vm.reload },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "fem" }, [_c("el-divider")], 1),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "centerCont" },
                    _vm._l(_vm.newList, function (item, index) {
                      return _c("div", { key: index, staticClass: "list" }, [
                        _c("div", { staticClass: "lf" }, [
                          _c("span", [_vm._v(_vm._s(item.styleNo))]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.multiLanguageDisplay(item.color))
                            ),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.multiLanguageDisplay(item.size))),
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(item.warehouseName))]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(item.locationName))]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "rt" },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.add(item, index)
                                  },
                                },
                              },
                              [_vm._v("新 增")]
                            ),
                          ],
                          1
                        ),
                      ])
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("el-divider"),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "listContent" },
                _vm._l(_vm.list, function (item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "list" },
                    [
                      !item.remove
                        ? _c(
                            "el-form",
                            { attrs: { "label-width": "100px" } },
                            [
                              _vm.deleteType
                                ? _c(
                                    "el-row",
                                    [
                                      _c("el-col", { staticClass: "delete" }, [
                                        _c("img", {
                                          attrs: {
                                            src: require("@/assets/image/shanchu.png"),
                                            alt: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onDelete(index)
                                            },
                                          },
                                        }),
                                      ]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: _vm.col } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "商品款号" } },
                                        [
                                          _c("span", [
                                            _vm._v(_vm._s(item.styleNo)),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-col",
                                    { attrs: { span: _vm.col } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "商品名称" } },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.multiLanguageDisplay(
                                                  item.goodsName
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-col",
                                    { attrs: { span: _vm.col } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "商品品牌" } },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.multiLanguageDisplay(
                                                  item.brandName
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-col",
                                    { attrs: { span: _vm.col } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "商品单位" } },
                                        [
                                          _c("span", [
                                            _vm._v(_vm._s(item.unit)),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "商品类别" } },
                                        [
                                          _c("span", [
                                            _vm._v(_vm._s(item.categoryName)),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-col",
                                    { attrs: { span: _vm.col } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "原仓库" } },
                                        [
                                          _c("span", [
                                            _vm._v(_vm._s(item.warehouseName)),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-col",
                                    { attrs: { span: _vm.col } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "库位号" } },
                                        [
                                          _c("span", [
                                            _vm._v(_vm._s(item.locationName)),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: _vm.col } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "剩余数量" } },
                                        [
                                          _c("span", [
                                            _vm._v(_vm._s(item.inventoryCount)),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-col",
                                    { attrs: { span: _vm.col } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "商品颜色" } },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.multiLanguageDisplay(
                                                  item.color
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-col",
                                    { attrs: { span: _vm.col } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "商品尺码" } },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.multiLanguageDisplay(
                                                  item.size
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-col",
                                    { attrs: { span: _vm.col } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "调拨数量" } },
                                        [
                                          _c("el-input-number", {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              min: 0,
                                              max: item.inventoryCount,
                                            },
                                            model: {
                                              value: item.num,
                                              callback: function ($$v) {
                                                _vm.$set(item, "num", $$v)
                                              },
                                              expression: "item.num",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: _vm.col } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "调拨仓库",
                                            required: true,
                                          },
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              staticClass: "filter-item",
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                filterable: "",
                                                clearable: "",
                                              },
                                              model: {
                                                value: item.wareHouse,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    item,
                                                    "wareHouse",
                                                    $$v
                                                  )
                                                },
                                                expression: "item.wareHouse",
                                              },
                                            },
                                            _vm._l(
                                              _vm.wareHouseList,
                                              function (item) {
                                                return _c("el-option", {
                                                  key: item.id,
                                                  attrs: {
                                                    label: item.name,
                                                    value: item.id,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-col",
                                    { attrs: { span: _vm.col } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "库位号",
                                            required: true,
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            staticStyle: { width: "100%" },
                                            attrs: { placeholder: "请输入" },
                                            model: {
                                              value: item.destLocation,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "destLocation",
                                                  $$v
                                                )
                                              },
                                              expression: "item.destLocation",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("el-divider"),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                }),
                0
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("取 消"),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.sure } },
                [_vm._v("确 认")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }